
import mDropdown from "../dropdown/index.vue";
import ExactModal from './components/ExactModal.vue';
import ManualModal from './components/ManualModal.vue'
import moment from 'moment';
import 'moment/locale/ru';
import {PropType} from "vue";
import {Value} from "./src/Value";
import {Action, ActionTypeEnum} from "./src/Action";
import {DatePiker} from "./src";
import "../../theme/moydom/less/blocks/date-picker/index.less";

moment.locale('ru');


export default {
    components: {
        mDropdown,
        ExactModal,
        ManualModal,
    },
    props: {
        modelValue: {
            type: Object as PropType<Value>,
        }
    },
    computed: {
        title: function (): string {
            if (this.modelValue) {
                return this.modelValue.toString();
            }
            return '';
        }
    },
    methods: {
        selectAction(action: Action): void {
            this.action = action;
            this.showModal = false;
            switch (action.type) {
                case ActionTypeEnum.EXACT_DATE:
                case ActionTypeEnum.MANUAL_PERIOD:
                    this.showModal = true;
                    break;
                default:
                    this.$emit('update:modelValue', action.valueFactory(null))
            }

        },
        setValue(value: any) {
            this.$emit('update:modelValue', this.action.valueFactory(value))
        },
    },
    created: function () {
        this.moment = moment;
    },
    data() {
        const service = new DatePiker();
        const value = this.modelValue;

        return {
            service: service,
            interval: value?.interval,
            action: service.getActionByValue(value),
            toggleMenu: false,
            value: null,
            showModal: false,
        }
    }
}
